// src/components/Subscribe.js
import React from 'react';
import { Button } from 'semantic-ui-react';
import { useStripe } from '@stripe/react-stripe-js';
import { useAuth } from '../contexts/AuthContext';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../firebase'; // Ensure you export firebaseConfig

const app = initializeApp(firebaseConfig);
const functions = getFunctions(app, 'us-central1'); // e.g., 'us-central1'

export default function Subscribe() {
  const stripe = useStripe();
  const { currentUser } = useAuth();
  
  const handleSubscribe = async () => {
    if (!stripe || !currentUser) return;
    
    const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
    const { data } = await createCheckoutSession();
    
    const { error } = await stripe.redirectToCheckout({
      sessionId: data.sessionId,
    });
    
    if (error) {
      console.error(error);
    }
  };
  
  return (
    <Button primary onClick={handleSubscribe}>
      Subscribe for $15/month
    </Button>
  );
}
